import { gql } from '@apollo/client'

export const GET_MEDIA = gql`
    query GetMedia($adAccountId: String!, $publisherId: String!, $campaignId: String!) {
        Media {
            photos(adAccountId: $adAccountId, publisherId: $publisherId, campaignId: $campaignId) {
                id
                name
                url
                width
                height
                thumbnail_url
            }
            videos(adAccountId: $adAccountId, publisherId: $publisherId, campaignId: $campaignId) {
                id
                name
                url
                duration
                width
                height
                thumbnails {
                    height
                    width
                    url
                }
            }
        }
    }
`

export const GET_PHOTOS = gql`
    query Photos($adAccountId: String!, $publisherId: String!, $campaignId: String!) {
        Media {
            photos(adAccountId: $adAccountId, publisherId: $publisherId, campaignId: $campaignId) {
                id
                name
                url
                thumbnail_url
            }
        }
    }
`

export const GET_VIDEOS = gql`
    query Videos($adAccountId: String!, $publisherId: String!, $campaignId: String!) {
        Media {
            videos(adAccountId: $adAccountId, publisherId: $publisherId, campaignId: $campaignId) {
                id
                name
                url
                duration
                thumbnails {
                    height
                    width
                    url
                }
            }
        }
    }
`

export const MIRROR_MEDIA = gql`
    mutation MirrorMedia(
        $media: [MediaInput!]!
        $campaignId: String!
        $adId: ID
        $replaceExisting: Boolean
        $formats: [String]
        $allowMultiple: Boolean!
    ) {
        mirrorMedia(
            media: $media
            campaignId: $campaignId
            adId: $adId
            replaceExisting: $replaceExisting
            allowMultiple: $allowMultiple
            formats: $formats
        ) {
            id
        }
    }
`
